import React, { useEffect, useState} from 'react'
import {Dialog, DialogTitle, DialogContent, Select, MenuItem, InputLabel, Button} from '@mui/material'
import { itemServices } from 'src/services/reservation/item/item.service'
import { useTranslate, useRecordContext, useNotify} from 'react-admin'
import SaveIcon from '@mui/icons-material/Save'
import LoadingButton from '@mui/lab/LoadingButton'
import { useReservationInfo } from '../../context/ReservationContext'

export const ChangeBillingStatusDialog = ({open, setOpen, refresh}) => {
    const notify = useNotify()
    const translate = useTranslate()
    const item = useRecordContext()
    const [isLoading, setIsLoading] = useState(false)
    const statusOptions = [
                      { id: 'BILLED', name: translate('ra.status.BILLED') },
                      { id: 'PENDING_BILLING', name: translate('ra.status.PENDING_BILLING') },
                      { id: 'NOT_REQUIRED', name: translate('ra.status.NOT_REQUIRED') },
                    ]
    const { reservationInfo, setReservationInfo } = useReservationInfo()
    const [selectedStatus, setSelectedStatus] = useState('')

    useEffect(() => {
        if (open && item?.hash_) {
            const currentStatus = reservationInfo?.billing_info?.[item.hash_]?.billable_status
            setSelectedStatus(currentStatus || '')
        }
    }, [open, item?.hash_, reservationInfo])
    

    const onSubmit = async() =>{
        setIsLoading(true)
        await itemServices.update_billing_status_item(selectedStatus, item.hash_).then(()=>{

            setReservationInfo((prevInfo) => {
                let newBillingInfo = { ...prevInfo?.billing_info }
                if (newBillingInfo[item?.hash_]) {
                    newBillingInfo[item?.hash_].billable_status = selectedStatus
                }
                return { ...prevInfo, billing_info: newBillingInfo }
            })

            setOpen(false)
            refresh()
            notify('ra.message.change_status', {
                type:'success',
                messageArgs:{status:translate(`ra.status.${selectedStatus}`)}
            })
        }).catch(()=>{
            notify('ra.message.update_status_error', {type:'error'})
        }).finally(()=>{
            setIsLoading(false)
        })
    }
  return (
    <div>
        <Dialog
            open = {open}
            onClose={()=>setOpen(false)}
            fullWidth
        >
            <DialogTitle>
                {translate('ra.title.update_status')}
            </DialogTitle>
            <DialogContent>
                <InputLabel id='billing_status'>{translate('ra.field.billing_status')}</InputLabel>
                <Select
                    id='billing_status'
                    fullWidth
                    value={selectedStatus}
                    size='small'
                    onChange={value=>setSelectedStatus(value.target.value)}
                >   
                    {
                        statusOptions.map(option=>(
                            <MenuItem value={option.id} key={option.id}>
                                {option.name}
                            </MenuItem>
                        ))
                    }
                </Select>
            </DialogContent>
            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', margin:'15px'}}>
                <LoadingButton
                    loading={isLoading}
                    variant='contained'
                    startIcon={<SaveIcon />}
                    onClick={onSubmit}
                >
                    {translate('ra.action.save')}
                </LoadingButton>
                <Button onClick={()=>setOpen(false)} variant='outlined' color='error'>
                    {translate('ra.action.cancel')}
                </Button>
            </div>
        </Dialog>
    </div>
  )
}